import cn from 'classnames';
import useStore from '@/stores/sider-menu';
import useUserStore from '@/stores/userStore';
import Avatar from '@/common/biz/user-avatar';
import AvatarPopover from './avatar-popover';

export default function AvatarCard() {
  const { collapsed } = useStore();
  const { user, displayName } = useUserStore();

  if (collapsed) {
    return (
      <div className="pt-30">
        <AvatarPopover>
          <div className={cn('py-1.5 flex items-center justify-center')}>
            <Avatar />
          </div>
        </AvatarPopover>
      </div>
    );
  }

  return (
    <div className="px-3 pt-3">
      <AvatarPopover>
        <div className={cn('px-2 py-1.5 flex items-center gap-2 select-none rounded-sm transition')}>
          <Avatar className="flex-none" />
          <div className="min-w-0 pr-2">
            <div className="text-sm font-medium truncate text-[#262626]">{displayName}</div>
            <div className="text-xs truncate text-[#525252]">{user?.email || ''}</div>
          </div>
        </div>
      </AvatarPopover>
    </div>
  );
}
